import script from "./vprofilelink.vue?vue&type=script&setup=true&lang=js"
export * from "./vprofilelink.vue?vue&type=script&setup=true&lang=js"

import "./vprofilelink.vue?vue&type=style&index=0&id=1f2e6e27&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f2e6e27"]])

export default __exports__